export default "__VITE_ASSET__19f49a2a__"